import { useState } from "react";

const TranslateMessage = ({ data }) => {
    const [show, setShow] = useState(true);
    if (!data) return data;
    return (
        <div>
            <hr />
            <span onClick={() => setShow(!show)} role="button" className="text-info hide-translation-btn">
                {show ? "Hide" : "Show"} translation
            </span>
            {show && <p className="mb-0">{data}</p>}
        </div>
    );
};

export default TranslateMessage;
